import Fetch, { V1 } from 'Util/fetcher';
import { errorLogger } from '@ajaibid/utils';
import { DEFAULT_GET_RESPONSE } from '@config/constanta';

export const getSearchFaq = (text) => {
  const resourceUrl = `${V1}faq/custom/?search=${text}`;
  return Fetch.get(resourceUrl)
    .then((resp) => resp.json)
    .catch((error) => {
      errorLogger('ERROR_API', error.message, { path: resourceUrl });
      return { ...DEFAULT_GET_RESPONSE, err_message: error.message };
    });
};
